import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b87c02cc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b87c02cc')) {
      api.createRecord('b87c02cc', component.options)
    } else {
      api.reload('b87c02cc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b87c02cc&", function () {
      api.rerender('b87c02cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2j2Mx8JWRO4zO/JS/comp/FavElement.vue"
export default component.exports